// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm_form__3-mp3","name":"ContactForm_name__W8fdO","number":"ContactForm_number__3pjWt","btn":"ContactForm_btn__2wHI4"};